var map = {
	"./ion-action-sheet.entry.js": [
		13772,
		8592,
		3772
	],
	"./ion-alert.entry.js": [
		37207,
		8592,
		7207
	],
	"./ion-app_8.entry.js": [
		39840,
		8592,
		9840
	],
	"./ion-avatar_3.entry.js": [
		6884,
		8592,
		6884
	],
	"./ion-back-button.entry.js": [
		96818,
		8592,
		6818
	],
	"./ion-backdrop.entry.js": [
		40326,
		326
	],
	"./ion-button_2.entry.js": [
		86611,
		8592,
		6611
	],
	"./ion-card_5.entry.js": [
		81016,
		8592,
		1016
	],
	"./ion-checkbox.entry.js": [
		83457,
		8592,
		3457
	],
	"./ion-chip.entry.js": [
		53520,
		8592,
		3520
	],
	"./ion-col_3.entry.js": [
		74399,
		4399
	],
	"./ion-datetime_3.entry.js": [
		25768,
		8592,
		5768
	],
	"./ion-fab_3.entry.js": [
		65555,
		8592,
		5555
	],
	"./ion-img.entry.js": [
		99646,
		9646
	],
	"./ion-infinite-scroll_2.entry.js": [
		52939,
		8592,
		2939
	],
	"./ion-input.entry.js": [
		58706,
		8592,
		8706
	],
	"./ion-item-option_3.entry.js": [
		13654,
		8592,
		3654
	],
	"./ion-item_8.entry.js": [
		43426,
		8592,
		3426
	],
	"./ion-loading.entry.js": [
		46597,
		8592,
		6597
	],
	"./ion-menu_3.entry.js": [
		4170,
		8592,
		4170
	],
	"./ion-modal.entry.js": [
		41663,
		8592,
		1663
	],
	"./ion-nav_2.entry.js": [
		18504,
		8592,
		8504
	],
	"./ion-popover.entry.js": [
		87416,
		8592,
		7416
	],
	"./ion-progress-bar.entry.js": [
		74870,
		8592,
		4870
	],
	"./ion-radio_2.entry.js": [
		14499,
		8592,
		4499
	],
	"./ion-range.entry.js": [
		92885,
		8592,
		2885
	],
	"./ion-refresher_2.entry.js": [
		77237,
		8592,
		7237
	],
	"./ion-reorder_2.entry.js": [
		62940,
		8592,
		2940
	],
	"./ion-ripple-effect.entry.js": [
		95833,
		5833
	],
	"./ion-route_4.entry.js": [
		7527,
		8592,
		7527
	],
	"./ion-searchbar.entry.js": [
		2222,
		8592,
		2222
	],
	"./ion-segment_2.entry.js": [
		53229,
		8592,
		3229
	],
	"./ion-select_3.entry.js": [
		31570,
		8592,
		1570
	],
	"./ion-slide_2.entry.js": [
		38774,
		8774
	],
	"./ion-spinner.entry.js": [
		36867,
		8592,
		6867
	],
	"./ion-split-pane.entry.js": [
		7156,
		7156
	],
	"./ion-tab-bar_2.entry.js": [
		88522,
		8592,
		8522
	],
	"./ion-tab_2.entry.js": [
		69112,
		8592,
		9112
	],
	"./ion-text.entry.js": [
		95761,
		8592,
		5761
	],
	"./ion-textarea.entry.js": [
		89410,
		8592,
		9410
	],
	"./ion-toast.entry.js": [
		43922,
		8592,
		3922
	],
	"./ion-toggle.entry.js": [
		93474,
		8592,
		3474
	],
	"./ion-virtual-scroll.entry.js": [
		48851,
		8851
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 50863;
module.exports = webpackAsyncContext;